import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatErr } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);   // null = checking, false = logged out, object = user
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    let result;
    try {
      const { data } = await api.get("/auth/me");
      result = data;
    } catch {
      result = false;
    }
    setUser(result);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.access_token) localStorage.setItem("cf_token", data.access_token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatErr(e) };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_e) {
      // ignore network errors on logout
    }
    localStorage.removeItem("cf_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
